<typography *ngIf="!value" look="inputPlaceholder">{{ placeholder }}</typography>
<ng-container *ngIf="value">
  <div class="flag iti__flag cursor-default" [ngClass]="flagClass"></div>

  <typography class="phone"> {{ value | imask: mask }} </typography>
</ng-container>
